import { Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { CheckoutService } from '@df/checkout/checkout.service';

@Injectable({
    providedIn: 'root'
})
export class CheckoutSuccessResolver implements Resolve<Checkout.ISuccessData> {
    constructor(private router: Router, private checkoutService: CheckoutService) {}

    resolve(): Promise<Checkout.ISuccessData> {
        return new Promise<Checkout.ISuccessData>((resolve, reject) => {
            this.checkoutService
                .loadSuccess()
                .then(result => {
                    const successData = result?.success;
                    if (successData) {
                        resolve(successData);
                    } else if (result?.post_redirect || result?.external_redirect) {
                        // we do nothing, redirect in progress
                    } else {
                        reject();
                    }
                })
                .catch(() => {
                    this.router.navigate(['/checkout']);
                    reject();
                });
        });
    }
}
